/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const Lti1p3PreventNonceReuseEnabledSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('LTI_1P3_PREVENT_NONCE_REUSE_ENABLED')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class Lti1p3PreventNonceReuseEnabledSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return Lti1p3PreventNonceReuseEnabledSettingParser.decode(input).map(res => new Lti1p3PreventNonceReuseEnabledSetting(res));
    }
    static unsafeDecode(input) {
        return Lti1p3PreventNonceReuseEnabledSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return Lti1p3PreventNonceReuseEnabledSettingParser.encode(data);
    }
    static schema() {
        return Lti1p3PreventNonceReuseEnabledSettingParser.schema();
    }
}
